
import { Box } from '@mui/system';
import '../App.css';
import { useState, useContext, useEffect, ChangeEvent } from 'react';
import styled from '@emotion/styled'
import { Grid, Popover, Backdrop, CircularProgress, Select, MenuItem, PopoverVirtualElement } from '@mui/material';
import { loginPageImage, loginPageImage2 } from '../assets/imgs';
import { useNavigate } from 'react-router-dom';
import { useLoginMutation, useRegisterMutation, useForgotPasswordMutation, useResetPasswordMutation, useLazyGetRegisterRoleDropDownListQuery } from '../features/auth/authApiSlice';
import { GlobalStateContext } from '../store/GlobalState';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../features/auth/authSlice';
import { useTranslation } from "react-i18next";
import IconButton from '@mui/material/IconButton';
import TranslateIcon from '@mui/icons-material/Translate';
import { useForm } from 'react-hook-form';
import FetchingItems from '../components/FetchingItems';

const loginPageInputStyle = {
    height: '60px',
    width: '400px',
    borderRadius: 0,
    fontSize: 'calc(14px + 0.4vw)',
    paddingLeft: '12px',
    fontWeight: 300

}

const loginPageContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const loginPageResetPasswordContainerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: 'calc(16px + 0.4vw)',
    width: '573px',
    margin: '0 auto',
    visibility: 'hidden',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageHeadingContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: '573px',
    margin: '0 auto',
    '@media (max-width: 600px)': {
        width: '300px'
    }
};

const LoginPageLabelContainer = styled.label`
    width: 173px;
    @media (max-width: 1080px) {
      /* Styles for small screens */
      width: 160px;
    }
    flex-wrap: wrap;
`;

const LoginPageLoginButton = styled.button`
    width: 400px;
    background: #21125B;
    color: white;
    font-size: calc(12px + 0.4vw);
    border-radius: 20px;
    height: 62px;
    font-weight: 600;
    cursor: pointer;
`

const LoginPageHeading1 = styled.p`
    font-weight: 400;
    font-size: calc(32px + 0.4vw);
    margin-top: 200px;
    margin-bottom: 0px;
`

const LoginPageHeading2 = styled.p`
    font-weight: 600;
    border-bottom: 5px solid #21125B;
    padding-bottom: 10px;
    font-size: calc(32px + 0.4vw);
    margin-bottom: 50px;
    margin-top: 32px;
`

const LoginPageImage = styled.img`
    height: 100%;
    object-fit: cover;
    width: 100%;
    height: 100%; 
`

const ForgotButton = styled.span`
    cursor: pointer;
`

const WrongPassword = styled.span`
    font-size: 16px;
    color: red;
`

const LoginPage = () => {
    const { t, i18n } = useTranslation();
    const globalState = useContext(GlobalStateContext)
    const [forgotPassword] = useForgotPasswordMutation()
    const [resetPassword] = useResetPasswordMutation()
    const [login] = useLoginMutation()
    const [register] = useRegisterMutation()
    const [email, setEmail] = useState("")
    const [emailaddress, setEmailAddress] = useState<String | null>("")
    const [token, setToken] = useState<String | null>("")
    const [password, setPassword] = useState("")
    const [resetpassword, setResetPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [errorMessagerg, setErrorMessagerg] = useState("")
    const [errorMessagefp, setErrorMessagefp] = useState("")
    const [errorMessagerp, setErrorMessagerp] = useState("")
    const [alertMessage, setAlertMessage] = useState("")
    const [registervariable, setRegisterVariable] = useState<JSX.Element | string | null>("Register")
    const [fpvariable, setFPVariable] = useState<JSX.Element | string | null>("Enter")
    const [rpvariable, setRPVariable] = useState<JSX.Element | string | null>("Enter")
    const [loginvariable, setLoginVariable] = useState<JSX.Element | string | null>("Login")
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setErrorMessagerg("")
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [anchorElfp, setAnchorElfp] = useState<HTMLButtonElement | null>(null);

    const handleClickfp = (event: React.MouseEvent<HTMLButtonElement>) => {
        setErrorMessagefp("")
        setAlertMessage("")
        setAnchorElfp(event.currentTarget);
    };

    const handleClosefp = () => {
        setAnchorElfp(null);
    };

    const openfp = Boolean(anchorElfp);
    const idfp = openfp ? 'simple-popoverfp' : undefined;



    const [openrp, setOpenrp] = useState(false);


    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        setEmailAddress(queryParameters.get("email"))
        setToken(queryParameters.get("token"))
        var arr = window.location.search.split('?');
        if (arr.length > 1 && arr[1] !== '') {
            setOpenrp(true)
        } else {
            setOpenrp(false)
        }

    }, [])

    const idrp = openrp ? 'simple-popoverrp' : undefined;

    const handleKeyDown = async function (e: any) {
        if (e.key === 'Enter') {
            await handleLogin(e)
        }
    }

    const handleResetPassword = async (e: any) => {
        e.preventDefault()
        setRPVariable(<CircularProgress color="inherit" />)
        if (resetpassword == "") {
            alert("Cannot empty password.")
            setRPVariable("Enter")
        }

        else {
            try {
                await resetPassword({ email: emailaddress, password: resetpassword, token: token }).unwrap().then(
                    () => {
                        alert("Password has been successfully changed")
                        setRPVariable("Enter")
                    }
                )
                setOpenrp(false)
            } catch (err: any) {
                console.log(err);
                setErrorMessagerp("There is something goes wrong")
                setRPVariable("Enter")
            }
        }

    }

    const handleForgotPassword = async (e: any) => {
        e.preventDefault()
        setFPVariable(<CircularProgress color="inherit" />)
        if (email == "") {
            alert("Cannot empty email.")
            setFPVariable("Enter")
        }
        else {
            try {
                await forgotPassword({ email: email }).unwrap().then(
                    () => {
                        setAlertMessage("Email sent! Please check email for forgotpassword.")
                        setFPVariable("Enter")
                    }
                )
            } catch (err: any) {
                console.log(err);
                setErrorMessagefp("Cannot use this email.")
                setFPVariable("Enter")
            }
        }

    }

    const handleLogin = async (e: any) => {
        e.preventDefault()
        setLoginVariable(<CircularProgress color="inherit" />)
        try {
            // var userData;
            // userData = await login({ email: email, password: password }).unwrap().then(
            await login({ email: email, password: password }).unwrap().then(
                (result) => {
                    setLoginVariable("Login")
                    const loginResponse = JSON.parse(result);
                    const { accessToken, refreshToken } = loginResponse;
                    const { token: refreshTokenToken, expires: refreshTokenExpires } = refreshToken;
                    dispatch(
                        setCredentials({
                            user: email,
                            refreshToken: refreshTokenToken,
                            accessToken: accessToken,
                            expires: refreshTokenExpires
                        })
                    );
                    localStorage.setItem('user', email);
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshTokenToken);
                    localStorage.setItem('expires', refreshTokenExpires);

                    globalState.setAccessToken(accessToken)
                    globalState.setRefreshToken(refreshTokenToken)
                    globalState.setExpires(refreshTokenExpires)
                }
            )
            setEmail('')
            setPassword('')
            navigate('/schedule')
        } catch (err: any) {
            console.log(err);
            setErrorMessage("Wrong password or email.")
            setLoginVariable("Login")
        }
    }

    const handleRegister = async (e: any) => {
        e.preventDefault()
        setRegisterVariable(<CircularProgress color="inherit" />)
        if (email == "") {
            alert("Cannot empty email.")
            setRegisterVariable("Register")
        }
        else if (password == "") {
            alert("Cannot empty password.")
            setRegisterVariable("Register")
        }
        else {
            try {
                await register({ email: email, password: password }).unwrap().then(
                    () => {

                        alert("Account has been successfully created.")
                        setRegisterVariable("Register")
                    }
                )
                setAnchorEl(null);
            } catch (err: any) {
                console.log(err);
                setErrorMessagerg("Cannot use this email.")
                setRegisterVariable("Register")
            }
        }

    }

    /*const forgotPassword = function () {
        // alert("Coming soon.")
        navigate('/change-password')
    }*/

    const TranslateIconClick = () => {
        i18n.changeLanguage(i18n.language == "en" ? "zh" : "en");
        localStorage.setItem("i18n", i18n.language);
        //console.log(i18n.language);
    }

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={12} md={6} sx={{ height: "100vh" }}>
                    {/* Photo */}
                    <LoginPageImage src={loginPageImage2} alt="login page photo" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <IconButton
                        onClick={() => TranslateIconClick()}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            marginLeft: '5px',
                            color: '#7e8080'
                        }}
                    >
                        <TranslateIcon />
                    </IconButton>
                    {/* Titles */}
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading1>{t("Confined Space Program")}</LoginPageHeading1>
                    </Box>
                    <Box sx={LoginPageHeadingContainerStyle} >
                        <LoginPageHeading2>{t("Login")}</LoginPageHeading2>
                    </Box>

                    {/* Input Boxes */}
                    <Box sx={loginPageContainerStyle}>
                        <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                        <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                        <input name="passowrd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={loginPageInputStyle} onKeyDown={handleKeyDown} />
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <WrongPassword>{errorMessage}</WrongPassword>
                    </Box>

                    {/* Buttons */}
                    {/* <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <ForgotButton onClick={forgotPassword}>{t("Forgot Password?")}</ForgotButton>
                    </Box> */}
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleLogin}>{loginvariable}</LoginPageLoginButton>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleClick}>{t("Register")}</LoginPageLoginButton>
                    </Box>
                    <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                        <LoginPageLabelContainer></LoginPageLabelContainer>
                        <LoginPageLoginButton onClick={handleClickfp}>{t("ForgotPassword")}</LoginPageLoginButton>
                    </Box>

                    <RegisterDialog
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        onClose={handleClose}
                    />
                    {/* <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorReference={"none"}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backdropFilter: "blur(5px)",
                        }}
                    >
                        <div
                            style={{
                                margin: "30px"
                            }}
                        >
                            <Box sx={LoginPageHeadingContainerStyle} >
                                <LoginPageHeading2>{t("Register")}</LoginPageHeading2>
                            </Box>
                            <Box sx={loginPageContainerStyle}>
                                <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                                <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                                <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                                <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                                <LoginPageLabelContainer>{("Role:")}</LoginPageLabelContainer>
                                <Select
                                    // onChange={(event) => { setType(event.target.value) }}
                                    sx={
                                        (() => {
                                            var { width, ...other } = loginPageInputStyle
                                            return { width: "415px", ".MuiOutlinedInput-notchedOutline": { borderColor: "black" }, ...other }
                                        })()
                                    }
                                >
                                    <MenuItem key="1" value="doe">
                                        Doe
                                    </MenuItem>
                                </Select>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                                <LoginPageLabelContainer>{("Company:")}</LoginPageLabelContainer>
                                <input name="company" type="company" value={password} onChange={(e) => setPassword(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <WrongPassword>{errorMessagerg}</WrongPassword>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <LoginPageLoginButton onClick={handleRegister}>{registervariable}</LoginPageLoginButton>
                            </Box>
                        </div>
                    </Popover> */}

                    <Popover
                        id={idfp}
                        open={openfp}
                        anchorEl={anchorElfp}
                        onClose={handleClosefp}
                        anchorReference={"none"}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backdropFilter: "blur(5px)",
                        }}
                    >
                        <div
                            style={{
                                margin: "30px"
                            }}
                        >
                            <Box sx={LoginPageHeadingContainerStyle} >
                                <LoginPageHeading2>{t("ForgotPassword")}</LoginPageHeading2>
                            </Box>
                            <Box sx={loginPageContainerStyle}>
                                <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                                <input name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <WrongPassword>{errorMessagefp}</WrongPassword>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <WrongPassword>{alertMessage}</WrongPassword>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <LoginPageLoginButton onClick={handleForgotPassword}>{fpvariable}</LoginPageLoginButton>
                            </Box>
                        </div>
                    </Popover>


                    <Popover
                        id={idrp}
                        open={openrp}
                        anchorReference={"none"}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backdropFilter: "blur(5px)",
                        }}
                    >
                        <div
                            style={{
                                margin: "30px"
                            }}
                        >
                            <Box sx={LoginPageHeadingContainerStyle} >
                                <LoginPageHeading2>{t("ResetPassword")}</LoginPageHeading2>
                            </Box>
                            <Box sx={loginPageContainerStyle}>
                                <LoginPageLabelContainer>{("Email:")}</LoginPageLabelContainer>
                                <input name="email" type="text" value={emailaddress as string | number | readonly string[] | undefined} onChange={(e) => setEmailAddress(e.target.value)} style={loginPageInputStyle} disabled />
                            </Box>
                            <Box sx={loginPageResetPasswordContainerStyle}>
                                <LoginPageLabelContainer>{("Token:")}</LoginPageLabelContainer>
                                <input name="email" type="text" value={token as string | number | readonly string[] | undefined} onChange={(e) => setToken(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                                <LoginPageLabelContainer>{("Password:")}</LoginPageLabelContainer>
                                <input name="passowrd" type="password" value={resetpassword} onChange={(e) => setResetPassword(e.target.value)} style={loginPageInputStyle} />
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <WrongPassword>{errorMessagerp}</WrongPassword>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <WrongPassword>{alertMessage}</WrongPassword>
                            </Box>
                            <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                                <LoginPageLabelContainer></LoginPageLabelContainer>
                                <LoginPageLoginButton onClick={handleResetPassword}>{rpvariable}</LoginPageLoginButton>
                            </Box>
                        </div>
                    </Popover>
                </Grid>
            </Grid>
        </>
    );
};

const RegisterDialog = ({ id, open, anchorEl, setAnchorEl, onClose }:
    {
        id: string | undefined
        open: boolean
        anchorEl: Element | null
        setAnchorEl: (x: HTMLButtonElement | null) => void
        onClose: () => void
    }
) => {
    const [postRegister, status] = useRegisterMutation()
    const { register, handleSubmit, reset, getValues, formState: { errors }, setError } =
        useForm(
            { defaultValues: { name: null, email: null, password: null, password2: null, roleId: null, companyName: null, phoneNumber: null } }
        )

    const [errorMessage, setErrorMessage] = useState("")
    const { t, i18n } = useTranslation();

    const onClosedWrapped = () => {
        reset({})
        setErrorMessage("")
        onClose()
    }

    const handleRegister = async (value: any) => {
        delete value.password2
        setErrorMessage("")
        try {
            await postRegister(value).unwrap().then(
                () => {
                    alert("Account has been successfully created.")
                }
            )
            setAnchorEl(null)
        } catch (err: any) {
            if ("data" in err) {
                var dataObj = JSON.parse(err.data)
                for (var key in dataObj) {
                    setError(key as any, { type: "custom", message: dataObj[key][0] })
                }
            }
            else
                setErrorMessage("Cannot use this email.")
        }
    }
    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClosedWrapped}
            anchorReference={"none"}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backdropFilter: "blur(5px)",
            }}
        >
            <div
                style={{
                    margin: "30px"
                }}
            >
                <Box sx={LoginPageHeadingContainerStyle} >
                    <LoginPageHeading2>{t("Register")}</LoginPageHeading2>
                </Box>
                <Box sx={loginPageContainerStyle}>
                    <LoginPageLabelContainer>{t("Name")}:</LoginPageLabelContainer>
                    <input type="text" {...register("name", { required: "Name is required" })} style={loginPageInputStyle} />
                </Box>
                {errors.name && <p style={{ color: "red" }}>{errors.name.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{t("Email")}:</LoginPageLabelContainer>
                    <input type="text" {...register("email", { required: "Email is required" })} style={loginPageInputStyle} />
                </Box>
                {errors.email && <p style={{ color: "red" }}>{errors.email.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{t("Phone Number")}:</LoginPageLabelContainer>
                    <input type="text" {...register("phoneNumber", { required: "Phone number is required" })} style={loginPageInputStyle} />
                </Box>
                {errors.email && <p style={{ color: "red" }}>{errors.email.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{("Password")}:</LoginPageLabelContainer>
                    <input type="password" {...register("password", { required: "Password is required", deps: "password2" })} style={loginPageInputStyle} />
                </Box>
                {errors.password && <p style={{ color: "red" }}>{errors.password.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{t("Repeat Password")}:</LoginPageLabelContainer>
                    <input type="password"
                        {...register("password2",
                            {
                                required: "Repeat the password here.",
                                validate: (value) => value !== getValues("password") ? "The password is not same as first input." : undefined
                            }
                        )}
                        style={loginPageInputStyle} />
                </Box>
                {errors.password2 && <p style={{ color: "red" }}>{errors.password2.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{t("Role")}:</LoginPageLabelContainer>
                    <FetchingItems<{ id: number, name: string }[]>
                        useLazyQuery={useLazyGetRegisterRoleDropDownListQuery}
                        render={(items, isLoading) => {
                            return (
                                <Select
                                    {...register("roleId", { required: "Role is required" })}
                                    sx={
                                        (() => {
                                            var { width, ...other } = loginPageInputStyle
                                            return { width: "415px", ".MuiOutlinedInput-notchedOutline": { borderColor: "black" }, ...other }
                                        })()
                                    }
                                >
                                    {
                                        isLoading ?
                                            <></>
                                            :
                                            items?.map((x, i) => (
                                                <MenuItem key={i} value={x.id}>
                                                    {x.name}
                                                </MenuItem>
                                            )) ??
                                            (<></>)
                                    }
                                </Select>
                            )
                        }}
                    />
                </Box>
                {errors.roleId && <p style={{ color: "red" }}>{errors.roleId.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '25px' }}>
                    <LoginPageLabelContainer>{("Company Name:")}</LoginPageLabelContainer>
                    <input type="companyName" {...register("companyName", { required: "Company is required" })} style={loginPageInputStyle} />
                </Box>
                {errors.companyName && <p style={{ color: "red" }}>{errors.companyName.message}</p>}
                <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                    <LoginPageLabelContainer></LoginPageLabelContainer>
                    <WrongPassword>{errorMessage}</WrongPassword>
                </Box>
                <Box sx={loginPageContainerStyle} style={{ marginTop: '15px' }}>
                    <LoginPageLabelContainer></LoginPageLabelContainer>
                    {status.isLoading ?
                        <LoginPageLoginButton><CircularProgress color="inherit" /></LoginPageLoginButton> :
                        <LoginPageLoginButton
                            onClick={(e) => {
                                e.preventDefault()
                                handleSubmit(handleRegister)()
                            }}
                        >
                            {t("Register")}
                        </LoginPageLoginButton>
                    }
                </Box>
            </div>
        </Popover>
    )
}

export default LoginPage;
